import { renderInDocument } from '@spotahome/soyuz/client';

import Countries from './Countries';

renderInDocument(Countries);
